<template>
  <!--ionic bug: do not inject dynamic class to ion-card while in ion-slides-->
  <ion-card mode="ios" class="item-loyalty-result">
    <ion-card-content>
      <!--header-->
      <div class="item-loyalty-result-header" :class="status">
        <h5 class="title m-0">{{ title }}</h5>
        <svg class="icon icon-keg"><use xlink:href="#icon-keg"></use></svg>
        <h6 class="volume all-center">{{ volume }}</h6>
      </div>
      <!--tables-->
      <div v-for="(table,index) in tables" :key="index">
        <table class="table table-loyalty-results" :class="status">
          <thead>
            <tr>
              <th>{{ table.title }}</th>
              <th class="text-right">{{ table.unit }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in table.data" :key="index">
              <td>{{ row.key }}</td>
              <td>{{ row.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--TODO notifications?-->
    </ion-card-content>
  </ion-card>
</template>

<script>
  export default {
    name: 'ItemLoyaltyResult',
    props: ['index', 'status', 'title', 'volume', 'tables'],
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  ion-card{
    width: 100%;
    margin: 0 1px 15px;
    background: transparent;
    border: 1px solid #bfbfbf;
    box-shadow: none !important;
  }
  ion-card-content{
    padding: 20px 15px 6px;
    text-align: center;
    background: transparent;
  }
</style>